export default __webpack_public_path__ + "static/media/outlined1_left.73b03a8d.svg";